import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classname';

export const Database = ({ width, height, className, fill, outline, theme }) =>
  outline ? (
    <svg
      width={width}
      height={height}
      className={cls(className, 'icon icon-database icon-database-outline')}
      viewBox="0 0 64 64"
      fill="#6E7DAF"
      xmlns="http://www.w3.org/2000/svg"
      stroke='#6e7daf'
    >
      <path d="M32,13a3,3,0,1,1,3-3A3,3,0,0,1,32,13Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,32,9Z" />
      <path d="M9,36a3,3,0,1,1,3-3A3,3,0,0,1,9,36Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,9,32Z" />
      <path d="M32,59a3,3,0,1,1,3-3A3,3,0,0,1,32,59Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,32,55Z"/>
      <path d="M55,36a3,3,0,1,1,3-3A3,3,0,0,1,55,36Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,55,32Z"/>
      <path d="M32,39a6,6,0,0,1-5.65-4A5.76,5.76,0,0,1,26,33a6,6,0,0,1,6-6,5.86,5.86,0,0,1,2,.35,6.07,6.07,0,0,1,2.24,1.4A6,6,0,0,1,37.65,31,5.76,5.76,0,0,1,38,33a6,6,0,0,1-6,6Zm0-10a4,4,0,0,0-4,4,3.91,3.91,0,0,0,.23,1.33,4,4,0,0,0,2.43,2.44A4,4,0,0,0,36,33a3.91,3.91,0,0,0-.23-1.33,4,4,0,0,0-.94-1.5,4.06,4.06,0,0,0-1.49-.94A4,4,0,0,0,32,29Z"/><path d="M20.69,45.31A1,1,0,0,1,20,45a1,1,0,0,1-.12-1.27l6.6-9.65a1,1,0,0,1,1-.42,1,1,0,0,1,.81.66,4,4,0,0,0,2.43,2.43,1,1,0,0,1,.66.81,1,1,0,0,1-.42,1l-9.65,6.6A1,1,0,0,1,20.69,45.31Zm6.5-8.72-2.66,3.88,3.88-2.66A5.88,5.88,0,0,1,27.19,36.59Z"/><path d="M36.71,32.33h-.13a1,1,0,0,1-.81-.66,4,4,0,0,0-2.43-2.43,1,1,0,0,1-.66-.81,1,1,0,0,1,.42-1l9.64-6.6A1,1,0,0,1,44,21a1,1,0,0,1,.11,1.27L37.54,31.9A1,1,0,0,1,36.71,32.33Zm-1.12-4.14a5.3,5.3,0,0,1,1.22,1.22l2.66-3.88Z"/>
      <path d="M32,62A29,29,0,1,1,61,33,29,29,0,0,1,32,62ZM32,6A27,27,0,1,0,59,33,27,27,0,0,0,32,6Z"/>
    </svg>
  ) : (
    <svg
      width={width}
      height={height}
      className={cls(className, 'icon icon-database icon-database-bold')}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      fill="#237cfb"
    >
      <path d="M32,4A29.3,29.3,0,0,0,4.75,23.09,29,29,0,0,0,46.93,57.86,29.29,29.29,0,0,0,60.42,27.23,29,29,0,0,0,32,4Zm0,56A27.26,27.26,0,0,1,6.64,42.26,27,27,0,0,1,45.92,9.87a27.24,27.24,0,0,1,12.54,28.5,27.28,27.28,0,0,1-22.3,21.31A27.65,27.65,0,0,1,32,60Z"/><path d="M32,6A27.26,27.26,0,0,0,6.64,23.74,27,27,0,0,0,45.92,56.13a27.24,27.24,0,0,0,12.54-28.5A27.28,27.28,0,0,0,36.16,6.32,27.65,27.65,0,0,0,32,6ZM9,36c-3.87,0-3.86-6,0-6S12.87,36,9,36ZM32,7c3.87,0,3.86,6,0,6S28.13,7,32,7Zm0,52c-3.87,0-3.86-6,0-6S35.87,59,32,59ZM44.13,22.25l-6.32,9.26a6,6,0,0,1-7.3,7.3l-9.26,6.33A1,1,0,0,1,20,45a1,1,0,0,1-.12-1.27l6.33-9.26a6,6,0,0,1,7.3-7.3l9.25-6.33A1,1,0,0,1,44,21,1,1,0,0,1,44.13,22.25ZM55,36c-3.87,0-3.86-6,0-6S58.87,36,55,36Z"/>
      <path d="M33,10a1,1,0,0,1-2,0A1,1,0,0,1,33,10Z"/>
      <path d="M10,33a1,1,0,0,1-2,0A1,1,0,0,1,10,33Z"/>
      <path d="M33,56a1,1,0,0,1-2,0A1,1,0,0,1,33,56Z"/>
      <path d="M56,33a1,1,0,0,1-2,0A1,1,0,0,1,56,33Z"/>
      <path d="M39.47,25.53l-2.66,3.88a5.3,5.3,0,0,0-1.22-1.22Z"/>
      <path d="M28.41,37.81l-3.88,2.66,2.66-3.88.18.23a3.33,3.33,0,0,0,.25.28.93.93,0,0,0,.14.14.31.31,0,0,0,.1.1,3.17,3.17,0,0,0,.39.34Z"/>
      <path d="M36,33a4,4,0,1,1-.23-1.33A3.91,3.91,0,0,1,36,33Z"/>
      <path d="M36,33a4,4,0,1,1-.23-1.33A3.91,3.91,0,0,1,36,33Z"/>
    </svg>
  );

Database.defaultProps = {
  width: 24,
  height: 24,
  // fill: '#6E7DAE',
  outline: true,
};

Database.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  fill: PropTypes.string,
  outline: PropTypes.bool,
};

export default Database;
